const protocolRegex = /^(https?:\/\/)/;
const forbiddenChars = /[ <>\"'|\\{}[\]]/;

/**
 * Checks if a URL string is valid and its domain is in the allowed list.
 * @param urlString The untrusted URL string to check.
 * @param allowedDomains Array of allowed domain names (e.g., ['example.com', 'sub.example.com']).
 * @returns true if valid and domain is allowed, false otherwise.
 */
export function isValidUrl(urlString: string, allowedDomains: string[]): boolean {
  try {
    const url = new URL(urlString);

    // Ensure protocol is http or https and the input string matches the full origin
    if (!protocolRegex.test(urlString)) {
      return false;
    }

    // Reject if forbidden characters are present
    if (forbiddenChars.test(urlString)) {
      return false;
    }
    
    // Check if the hostname matches any allowed domain (exact match)
    return allowedDomains.some(domain => url.hostname === domain);
  } catch {
    // Invalid URL
    return false;
  }
}